import {
  ButtonLooks,
  ButtonSizes,
  DialogSizes,
  StandardButton,
  StandardDialog,
  brandfolderColorPalette
} from '@brandfolder/react';
import { t } from '@lingui/macro';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

const StyledDialog = styled(StandardDialog)`
  .bf-dialog__inner{
    height: fit-content;
  }
  .bf-dialog__type{
  }
  .bf-dialog__body {
    padding: 0 24px 24px;
  }

  .bf-dialog__footer{
    margin-top: 0;
  }

  p {
    margin: 0 0 24px 0;
    color: ${brandfolderColorPalette.neutrals[700]};
    font-size: 14px;
    line-height: 1.5;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

interface SameNameDetectedModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onCreateNew: () => void;
}

export const SameNameDetectedModal: FunctionComponent<SameNameDetectedModalProps> = ({
  isOpen,
  onCancel,
  onCreateNew
}) => (
  <StyledDialog
    className="same-name-detected-modal"
    id="same-name-detected-modal"
    labels={{
      closeButtonLabel: 'Close'
    }}
    open={isOpen}
    setOpen={onCancel}
    showTitle={true}
    size={DialogSizes.Small}
    title={t`Same name detected`}
  >
    <p>
      {t`Someone with this name already exists in your Brandfolder. Do you want to create a new person with the same name?`}
    </p>
    <ButtonContainer>
      <StandardButton
        look={ButtonLooks.Secondary}
        onClick={onCancel}
        size={ButtonSizes.XSmall}
      >
        {t`Cancel`}
      </StandardButton>
      <StandardButton
        look={ButtonLooks.Primary}
        onClick={onCreateNew}
        size={ButtonSizes.XSmall}
      >
        {t`Create new`}
      </StandardButton>
    </ButtonContainer>
  </StyledDialog>
);
